export default __webpack_public_path__ + "static/media/bi-file-earmark-pdf.51d0e8ce.svg";